import { Grid } from '@material-ui/core';
import { StandardDialog, Button } from '@roc/ui';
import { observer } from 'mobx-react';
import { ExpectedClosingDateStore } from '../../../stores/documentForms/expectedClosingDateStore';
import { Document } from '@roc/feature-types';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import WithDocumentActions from '../../../utils/withDocumentActions';
import { ClosingDateContainer } from './closingDateContainer';

export type ExpectedClosingDateDialogProps = {
  open?: boolean;
  onClose?: () => void;
  loanId: string;
  store: ExpectedClosingDateStore;
  document: Document;
};

export const ExpectedClosingDateDialog = observer(
  (props: ExpectedClosingDateDialogProps) => {
  const { open, onClose, loanId, store, document } = props;

  const onSubmit = async () => {
    await store.submitexpectedClosingDateState();
  };

  const getContent = () => {
    return (
      <ClosingDateContainer store={store} />
    );
  }

  const getActions = () => {
    return (
      <Grid container spacing={1} justifyContent="flex-end">
        <Grid item>
          <Button
            onClick={onClose}
            color="primary"
            variant="outlined"
            testId="cancel"
          >
            Cancel
          </Button>
        </Grid>
        <Grid item>
          <WithDocumentActions
            document={document}
            component={Button}
            onClick={onSubmit}
            color="primary"
            variant="contained"
            testId="confirm"
            disabled={!store.canSubmitExpectedClosingDate()}
          >
            Submit
          </WithDocumentActions>
        </Grid>
      </Grid>
    );
  }

  return (
    <> {document?.taskId ? (
      <CustomTaskDialog
        open={open}
        title="Expected Closing Date"
        handleClose={onClose}
        dialogContent={getContent()}
        dialogActions={getActions()}
        taskId={document?.taskId}
      />
    ) : (
      <StandardDialog
        open={open}
        title="Expected Closing Date"
        maxWidth="sm"
        handleClose={onClose}
        dialogContent={getContent()}
        dialogActions={getActions()}
      />
    )}
    </>
  );
});

export default ExpectedClosingDateDialog;
